import type { S3PBallPathQuery, S3PBallResponse } from '@clsplus/api-types/s3p-manage'

import { requestApiJsonOrThrow } from '../request-handler'

function getS3PBallDiagnosticData(query: S3PBallPathQuery): Promise<Array<S3PBallResponse>> {
  return requestApiJsonOrThrow<Array<S3PBallResponse>>('s3p/diagnostics/ball', {
    params: query,
  })
}

export const getS3PBallQuery = (queryParams: S3PBallPathQuery | undefined) => ({
  queryKey: ['s3p-ball', queryParams],
  queryFn: () =>
    queryParams
      ? getS3PBallDiagnosticData({
          ...queryParams,
        })
      : null,
})
